export const refreshTableTaskToggle = (value: boolean) => {
    return {
        payload: value,
        type: 'REFRESH_TABLE_TASK_TEMPLATE_TOGGLE'
    };
}